// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__nJR4M","withMobileMargins":"DateRangeInput_withMobileMargins__PmSgY","arrowIcon":"DateRangeInput_arrowIcon__2EkSk"};